(function () {
  'use strict';

  angular.module('app').service('ClientProfileModalService', ClientProfileModalService);

  ClientProfileModalService.$inject = ['ModalService'];

  function ClientProfileModalService(ModalService) {
    var service = {
      openClientProfileInfoModal: openClientProfileInfoModal,
    };

    return service;

    ////////////////////////

    function openClientProfileInfoModal(clientProfileId) {
      ModalService.showModal({
        templateUrl: './app/ajs/client-profiles/modals/client-profile-info-modal.html',
        controller: ClientProfileInfoModalCtrl,
        controllerAs: 'vm',
        inputs: {
          clientProfileId: clientProfileId,
        },
      }).then(function (modal) {
        modal.element.modal();
      });

      ClientProfileInfoModalCtrl.$inject = [
        'CONFIGURATIONS',
        'clientProfileId',
        'ClientProfileService',
        'ClientProfileSeasonService',
        'ClientProfileProductCategorySettingService',
        'ClientProfileProductSettingService',
        'PriceListService',
      ];
    }

    function ClientProfileInfoModalCtrl(
      CONFIGURATIONS,
      clientProfileId,
      ClientProfileService,
      ClientProfileSeasonService,
      ClientProfileProductCategorySettingService,
      ClientProfileProductSettingService,
      PriceListService
    ) {
      var vm = this;

      vm.dateDisplay = CONFIGURATIONS.DATE_DISPLAY;

      // Methods
      vm.showClientProfileSeason = showClientProfileSeason;

      // Initializers
      getPriceLists();

      function getClientProfile() {
        ClientProfileService.getClientProfile(clientProfileId).then(function (data) {
          vm.clientProfile = data;

          // Load current client profile season
          if (vm.clientProfile.client_profile_seasons.length > 0) {
            showClientProfileSeason(vm.clientProfile.client_profile_seasons[0]);
          }
        });
      }

      function showClientProfileSeason(clientProfileSeason) {
        vm.clientProfileSeason = null;
        vm.loadingClientProfileSeason = true;
        ClientProfileSeasonService.getClientProfileSeason(
          clientProfileSeason,
          vm.clientProfile.id
        ).then(function (data) {
          vm.clientProfileSeason = data;

          vm.generalSettings = ClientProfileSeasonService.setGeneralSettings(
            vm.clientProfileSeason.client_profile_general_settings,
            vm.priceLists
          );
          vm.productCategorySettings =
            ClientProfileProductCategorySettingService.setProductCategorySettings(
              vm.clientProfileSeason.client_profile_product_category_settings,
              vm.priceLists
            );
          vm.productSettings = ClientProfileProductSettingService.setProductSettings(
            vm.clientProfileSeason.client_profile_product_settings,
            vm.priceLists
          );

          vm.loadingClientProfileSeason = false;
        });
      }

      function getPriceLists() {
        PriceListService.getPriceLists({ get: 'active', contact_type: 'client' }).then(function (
          data
        ) {
          vm.priceLists = data.items;

          getClientProfile();
        });
      }
    }
  }
})();
